import type { ManageAPI } from "~/manage-api/types";
import { getDay } from "../../utils";

export const sortByStoreName = (lunch: ManageAPI.Lunch[] = []) => {
    return lunch.sort((a, b) =>
        a.store.name.localeCompare(b.store.name, undefined, {
            numeric: true,
            sensitivity: 'base'
        })
    );
};

export const sortMenuItemsByDay = (item: ManageAPI.Lunch, locale: string) => {
    return [...item.dailyLunchMenus].sort((a, b) => {
        const dayA = Number(getDay(a.day)) || 0;
        const dayB = Number(getDay(b.day)) || 0;
        return dayA - dayB;
    });
};